import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getAiBotSettings, updateAiBotSettings } from './actionCreators';
import { AiBotConfigState, SLICE_NAME, initialState } from './models';

export const aiBotConfigSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAiBotSettings.fulfilled, (state: AiBotConfigState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.settings = payload;
      })
      .addCase(updateAiBotSettings.fulfilled, (state: AiBotConfigState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.settings = payload;
      })
      .addMatcher(isPending(getAiBotSettings, updateAiBotSettings), (state: AiBotConfigState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getAiBotSettings, updateAiBotSettings), (state: AiBotConfigState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
